<template>
  <div class="400error">
    <div class="link-div-top">
      <router-link to="./top" class="page_link">Home</router-link> > <router-link to="./ErrorMessage" class="page_link">Error Message</router-link> > 400 SSL Certificate Error
    </div>
    <br /><br /><br />
    <div class="qa">
      <h1>Q. What is "400 SSL Certificate Error"?</h1>
      <img alt="400_ssl_certificate_error" src="../../assets/400_ssl_certificate_error.png">
      <h3>Answer</h3>
      <p class="answer">
        You haven't the Client Certificate of SUZUKI System.<br />
        Try the following:<br />
        - Clear the browser cache manual:<a href="/ClearBrowsingData.pdf" target="_blank" rel="noopener noreferrer">ClearBrowsingData.pdf</a><br />
        - Close all browsers and access again<br />
        - Select the correct client certificate<br />
        If you still see this error, please contact your user controller or SUZUKI's <br />certificate manager(<a href="mailto:certmgr@hhq.suzuki.co.jp">certmgr@hhq.suzuki.co.jp</a>), and re-issue the certificate.
      </p>
    </div>
    <br /><br />
    <div class="link-div-bottom">
      <router-link to="./ErrorMessage"><img id="back" src="/arrow_back.png" v-on:mouseover="imageBackChange" v-on:mouseleave="imageBackReturn" /></router-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<router-link to="./403error"><img id="forward" src="/arrow_forward.png" v-on:mouseover="imageForwardChange" v-on:mouseleave="imageForwardReturn" /></router-link>
    </div>
  </div>
</template>
<style>
.qa {
  min-width:800px;
  width:auto !important;
  width:800px;
  border-style:solid;
  border-width:1px;
  border-color:gray;
  border-radius:3px;
  padding:20px;
}
.answer {
  font-size:20px;
}

.link-div-top {
  text-align:left;
}

.link-div-bottom {
  text-align:center;
}

#forward {
  border-style:solid;
  border-width:1px;
  border-color:gray;
}

#back {
  border-style:solid;
  border-width:1px;
  border-color:gray;
}

</style>
<script>
export default {
  methods: {
    imageForwardChange: function () {
      var img = document.getElementById('forward')
      img.src = '/arrow_forward_on.png'
    },
    imageForwardReturn: function () {
      var img = document.getElementById('forward')
      img.src = '/arrow_forward.png'
    },
    imageBackChange: function () {
      var img = document.getElementById('back')
      img.src = '/arrow_back_on.png'
    },
    imageBackReturn: function () {
      var img = document.getElementById('back')
      img.src = '/arrow_back.png'
    }
  }
}
</script>
